import { z } from "zod";

import { cardTypeSchema } from "./enums";
import { fieldSchema } from "./field";

export const cardSchema = z.object({
	cardType: cardTypeSchema,
	fields: z.array(fieldSchema),
});
export type Card = z.infer<typeof cardSchema>;
